/**
 *@description use to detect device
 */

const DeviceUtils = {
  isMobile: function () {
    // Refer to _breakpoint.scss for responsive breakpoints
    return window.matchMedia("(max-width: 671px)").matches;
  },
  isTablet: function () {
    return window.matchMedia("(min-width: 672px) and (max-width: 1055px)").matches;
  },
  // Note: follow css screen checking for .page-side (related SLSSIT-4074)
  // device in landscape with specific ratio
  isDeviceInLandscape: function () {
    return window.matchMedia(
      "(max-width: 1055px) and (min-aspect-ratio: 13/9) and (min-width: 600px)",
    ).matches;
  },
  isDekstop: function () {
    return window.matchMedia("(min-width: 1056px) and (max-width: 1365.99px)").matches;
  },
  isDesktopLarge: function () {
    return window.matchMedia("(min-width: 1366px)").matches;
  },
  isIos: function () {
    return (
      /iPhone|iPad/i.test(navigator.userAgent) ||
      (navigator.userAgent.toLowerCase().indexOf("macintosh") > -1 && navigator.maxTouchPoints > 1) // for ios13 and above
    );
  },
};

export default DeviceUtils;
